import React, { useState } from 'react';
import { MappedCards } from '@components/storie-successo/mapped-cards/mapped-cards';
import { GenericSlider } from '@components/common/carousel/generic-slider';
import { useLayoutBreakpoint } from '@hooks/use-layout-breakpoint';

function StorieSuccessoCarousel({ stories = [], id }) {
  const [visibleSlideNumber, setVisibleSlideNumber] = useState(0);
  const [showArrows, setShowArrows] = useState(true);
  const breakpoint = useLayoutBreakpoint();
  const storiesSlides = React.useMemo(() => {
    const slides = [];
    let index;
    const isMobile = ['xs', 'sm', 'md'].indexOf(breakpoint) >= 0;
    const chunk = isMobile ? 1 : 3;
    let maxLength;
    for (index = 0, maxLength = stories?.length; index < maxLength; index += chunk) {
      const nextChunk = index + chunk;
      slides.push(stories.slice(index, nextChunk));
    }
    return slides?.map((story) => <MappedCards data={story} setShowArrows={setShowArrows} />);
  }, [stories, breakpoint]);

  return (
    <section id={`success_stories_section_${id}`}>
      <GenericSlider
        autoPlay
        showArrows={showArrows}
        currentSlideIndex={visibleSlideNumber}
        slides={storiesSlides}
        onSlideChange={setVisibleSlideNumber}
        cyclic
        id={`success_stories_carousel_${id}`}
        hidePositionIndicators
      />
    </section>
  );
}

StorieSuccessoCarousel.displayName = 'StorieSuccesso - Carousel';

export default StorieSuccessoCarousel;
